import { TimelineMax, Power4 } from 'gsap/all';
import { qs } from '@/scripts/utils';

export default function pictureAnimation(el) {
  const orientation = el.getAttribute('data-orientation');
  const initClipPath = orientation === 'left' ? 'inset(0.01% 100% 0.03% 0%)' : 'inset(0.01% 0.02% 0.03% 100%)';
  el.removeAttribute('data-orientation');
  const image = qs('.picture__div-img', el);
  const tl = new TimelineMax();

  tl.addLabel('strat')
    .set(el, { autoAlpha: 1 })
    .fromTo(image, 1.2, {
      scale: 1.6,
      autoAlpha: 0,
    }, {
      scale: 1,
      autoAlpha: 1,
      ease: Power4.easeInOut,
      clearProps: 'transform',
    }, 'start')
    .fromTo(el, 1, {
      clipPath: initClipPath,
      webkitClipPath: initClipPath,
    }, {
      clipPath: 'inset(0.01% 0.02% 0.03% 0%)',
      webkitClipPath: 'inset(0.01% 0.02% 0.03% 0%)',
      ease: Power4.easeOut,
      clearProps: 'all',
    }, 'start+=0.4');

  return tl;
}
